<template>
  <!-- TODO: 增加搜索、过滤 -->
  <!-- TODO: 网站来人主动通知客服端 -->
  <div id='bd-queue-table'>
    <el-row style="margin-top: 5px; margin-bottom: 5px; height: 20px;">
      <el-col :span="1"><el-button size="mini" @click="refreshData()"><i class="el-icon-refresh"></i>刷新</el-button></el-col>
    </el-row>
    <el-table v-loading="isLoading" :data="userQueues.content" empty-text="暂无排队" border style="width: 100%" highlight-current-row>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="visitor.nickname" label="访客"></el-table-column>
      <el-table-column prop="visitor.client" label="来源渠道"></el-table-column>
      <!--<el-table-column prop="visitor.connectionStatus" label="状态">
        <template slot-scope="scope">{{ scope.row.visitor.connectionStatus === 'connected' ? '在线' : '离线' }}</template>
      </el-table-column>-->
      <el-table-column prop="createdAt" label="入队时间">
        <template slot-scope="scope">{{ scope.row.createdAt != null ? scope.row.createdAt.substring(5) : '' }}</template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="doAcceptQueue(scope.$index, scope.row)" type="text" size="small">
            接入会话
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="10"
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="userQueues.totalElements">
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'bd-main',
  data () {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters([ 'userQueues', 'userCurrentQueue' ]),
  },
  methods: {
    ...mapActions([ 'queryQueues', 'updateCurrentQueue', 'acceptQueue', 'ignoreQueue' ]),
    //
    // isDisabled (record) {
    //   return record.visitor.connectionStatus !== 'connected'
    // },
    doAcceptQueue (index, queue) {
      // console.log('doAcceptQueue', this.userCurrentQueue)
      // TODO: 添加loading进度提示
      this.acceptQueue(queue.qid)
    },
    doIgnoreQueue (index, queue) {
      // console.log('doIgnoreQueue', this.userCurrentQueue)
      // TODO: 添加loading进度提示
      this.ignoreQueue(queue.qid)
    },
    handleSuccess(response) {
      this.isLoading = false
    },
    handleError(error) {
      this.isLoading = false
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val - 1}`);
      this.isLoading = true
      let payload = { page: val - 1, size: 10, successcb: this.handleSuccess, failedcb: this.handleError }
      this.queryQueues(payload)
    },
    refreshData() {
      this.isLoading = true
      let payload = { page: 0, size: 10, successcb: this.handleSuccess, failedcb: this.handleError }
      this.queryQueues(payload)
    }
  },
  created() {
    this.refreshData()
  },

}
</script>

<style scoped>

</style>
